import React from "react";

type SwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  showLabel?: boolean;
  labelPlacement?: "left" | "right";
  description?: string;
  showDescription?: boolean;
  disabled?: boolean;
  name?: string;
  id?: string;
};

const Switch: React.FC<SwitchProps> = ({
  checked,
  onChange,
  label,
  showLabel = true,
  labelPlacement = "right",
  description,
  showDescription = false,
  disabled = false,
  name,
  id,
}) => {
  const handleToggle = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  const switchLabel = label ?? (checked ? "On" : "Off");

  return (
    <div className="inline-flex flex-col">
      <button
        type="button"
        id={id}
        role="switch"
        aria-checked={checked}
        aria-label={switchLabel}
        disabled={disabled}
        onClick={handleToggle}
        className={`inline-flex items-center gap-2 bg-transparent border-none p-0 ${
          disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
        } ${labelPlacement === "left" ? "flex-row-reverse" : "flex-row"}`}
      >
        {/* Track */}
        <span
          className={`relative inline-flex h-[24px] w-[44px] shrink-0 items-center rounded-full px-[2px] transition-colors duration-200 ${
            checked ? "bg-[#2B8565]" : "bg-[#E8E8E8]"
          }`}
        >
          {/* Thumb */}
          <span
            className={`inline-block h-[18px] w-[18px] rounded-full bg-white shadow-sm transition-transform duration-200 ${
              checked ? "translate-x-[20px]" : "translate-x-0"
            }`}
          />
        </span>

        {showLabel && (
          <span className="text-sm font-semibold text-text-heading select-none">
            {switchLabel}
          </span>
        )}
      </button>

      {showDescription && description && (
        <span className="mt-1 text-xs text-gray">{description}</span>
      )}
    </div>
  );
};

export default Switch;
